

export let NSCombos = {};

NSCombos.objs = {};

NSCombos.get_select_SelectedKey = function(e_select)
{
	var i_pos = e_select.selectedIndex;
	if(i_pos>-1)
	{
		return e_select.options.item(i_pos).getAttribute("value");
	}
};

NSCombos.get_select_SelectedDesc = function(e_select)
{
	var i_pos = e_select.selectedIndex;
	if(i_pos>-1)
	{
		return e_select.options.item(i_pos).innerHTML;
	}
};

NSCombos.get_select_SelectedKey_bySelectId = function(s_e_select_id)
{
	var e_select = document.getElementById(this.s_e_select_id);
	var i_pos = e_select.selectedIndex;
	if(i_pos>-1)
	{
		return e_select.options.item(i_pos).getAttribute("value");
	}
};



//f_onSelect(key)
NSCombos.objs.Combo = function (s_id_select, f_onSelect, a_elems_desc, a_elems_keys)
{
	this.id_select = s_id_select;
	this.f_onSelect = f_onSelect;
	
	this.selected_key = null;

	this.a_elems_desc = null;
	this.a_elems_keys = null;

	this.reset(a_elems_desc, a_elems_keys);
	
}

NSCombos.objs.Combo.prototype.f_onSelectChange = function()
{
	var s_key = this.getSelectedKey();
	if (s_key != null && s_key != "")
	{
		this.f_onSelect(s_key);
	}
};

NSCombos.objs.Combo.prototype.reset = function(a_elems_desc, a_elems_keys, an_empty_option)
{
	var this_ = this;
	var e_select = document.getElementById(this.id_select);
	e_select.innerHTML = "";

	this.a_elems_desc = a_elems_desc;
	this.a_elems_keys = (a_elems_keys != null)? a_elems_keys : a_elems_desc; 
	
	e_select.onchange = function()
		{
			this_.f_onSelectChange();
		};
	
	/*
	var f_get_onclick_func_ = function (i_pos)
	{
		return function()
		{
			this_.f_onSelect(this_.a_elems_keys[i_pos]);
		};
	}
	*/
	
	
	//Let's create an empty option
	if( an_empty_option ) {
		var e_empty_option = document.createElement("option");
		e_empty_option.setAttribute("value", "");
		e_empty_option.innerHTML = "";
		e_select.appendChild(e_empty_option);
	}
	
	for(var i=0; i<a_elems_desc.length; i++)
	{
		/*
			<option>Action</option>
		*/
		var e_option = document.createElement("option");
		e_option.setAttribute("value", this_.a_elems_keys[i]);
		e_option.innerHTML = a_elems_desc[i];
		
		//e_option.onclick = f_get_onclick_func_(i);
		
		e_select.appendChild(e_option);
		
	}
	
	this_.f_onSelectChange();
	
	
}


NSCombos.objs.Combo.prototype.getSelectedKey = function()
{
	var e_select = document.getElementById(this.id_select);
	var i_pos = e_select.selectedIndex;
	if(i_pos>-1)
	{
		return e_select.options.item(i_pos).getAttribute("value");
	}
	


}

NSCombos.objs.Combo.prototype.setSelected_by_desc = function(s_desc)
{
	var e_select = document.getElementById(this.id_select);
	e_select.value = s_desc;

}

NSCombos.objs.Combo.prototype.setSelected_by_key = function(key)
{
	var e_select = document.getElementById(this.id_select);
	e_select.value = key;

}


	/*
	var NSCombos = {
		//init: init,
		
		objs: Objs
		/*
			Objs contains Combo object
				Combo functions:
					f_onSelectChange
					reset
					getSelectedKey
					setSelected_by_desc
		* /

	};
	*/


